import { render } from "./PuzzleTypeView.vue?vue&type=template&id=2c62268c&scoped=true"
import script from "./PuzzleTypeView.vue?vue&type=script&lang=js"
export * from "./PuzzleTypeView.vue?vue&type=script&lang=js"

import "./PuzzleTypeView.vue?vue&type=style&index=0&id=2c62268c&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c62268c"]])

export default __exports__